/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WaveSplitsEventLookupQueryVariables = {|
  eventId: string
|};
export type WaveSplitsEventLookupQueryResponse = {|
  +pgaTourEvent: ?{|
    +pgatoureventcourseSet: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +course: {|
            +name: string
          |},
        |}
      |}>
    |}
  |}
|};
export type WaveSplitsEventLookupQuery = {|
  variables: WaveSplitsEventLookupQueryVariables,
  response: WaveSplitsEventLookupQueryResponse,
|};
*/


/*
query WaveSplitsEventLookupQuery(
  $eventId: ID!
) {
  pgaTourEvent(eventId: $eventId) {
    pgatoureventcourseSet {
      edges {
        node {
          id
          course {
            name
            id
          }
        }
      }
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WaveSplitsEventLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "pgaTourEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourEventCourseTypeConnection",
            "kind": "LinkedField",
            "name": "pgatoureventcourseSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventCourseTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PGATourEventCourseType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PGATourCourseType",
                        "kind": "LinkedField",
                        "name": "course",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WaveSplitsEventLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "pgaTourEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourEventCourseTypeConnection",
            "kind": "LinkedField",
            "name": "pgatoureventcourseSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventCourseTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PGATourEventCourseType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PGATourCourseType",
                        "kind": "LinkedField",
                        "name": "course",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ba35a1a47c83e9c47362214e24a902c1",
    "id": null,
    "metadata": {},
    "name": "WaveSplitsEventLookupQuery",
    "operationKind": "query",
    "text": "query WaveSplitsEventLookupQuery(\n  $eventId: ID!\n) {\n  pgaTourEvent(eventId: $eventId) {\n    pgatoureventcourseSet {\n      edges {\n        node {\n          id\n          course {\n            name\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a11aa4def2577bdcd72a5ecd18c5e3eb';

module.exports = node;
